module.exports = __webpack_public_path__ + "img/footer.ce009e9e.png";